<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Michael Franks is a writer who enjoys building stories that involve a wide range of human emotions. He has a wealth of life experience having spent many years in military service around the world and holds a BSc in Psychology. His aim in his writing is to touch the senses of the reader and enable them to experience the emotions of the characters in the story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6a1d4d78